
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/server-rendering",
      function () {
        return require("private-next-pages/material-ui/guides/server-rendering.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/server-rendering"])
      });
    }
  